import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import ClaimCard from 'layouts/public/employee-onboard/useronboard'
import EnterpriseOnboardLayout, { submitInvitePassword } from 'layouts/public/enterprise-onboard'
import Download from 'layouts/authentication/register/personal/download'
import Handoff from 'layouts/public/handoff'

const EmployeeOnBoard = ComponentLoader(
  lazy(() => import('../layouts/public/employee-onboard/onboard-form'))
)

const Login = ComponentLoader(
  lazy(() => import('../layouts/public/employee-onboard/login'))
)

const GeneratePass = ComponentLoader(
  lazy(() => import('../layouts/public/genreate_pass'))
)

const OnboardEnterprise = ComponentLoader(
  lazy(() => import('../layouts/public/employee-onboard/login'))
)

const Plans = ComponentLoader(
  lazy(() => import('../layouts/public/plans/plans'))
)

const Marketplace = ComponentLoader(
  lazy(() => import('../layouts/public/marketplace'))
)

const BrandDetails = ComponentLoader(
  lazy(() => import('../layouts/public/marketplace/brand-details'))
)

const Storefront = ComponentLoader(
  lazy(() => import('../layouts/public/storefront/storefront'))
)

const CampaignJoin = ComponentLoader(
  lazy(() => import('../layouts/public/campaign-join'))
)
const CampaignStatus = ComponentLoader(
  lazy(() => import('../layouts/public/campaign-status'))
)

// const Demos = ComponentLoader(
//   lazy(() => import('../layouts/authentication/register/personal/demo'))
// )
// const Download = ComponentLoader(
//   lazy(() => import('../layouts/authentication/register/personal/download'))
// )

const INVITE_SUCCESS_STATE = { passwordSet: true }

const PublicRoutes = [
  {
    path: 'handoff',
    element: <Handoff />,
  },
  {
    path: 'plans',
    element: <Plans />,
  },
  {
    path: 'claim-card',
    element: <ClaimCard />,
    children: [
      {
        path: ':accountId',
        index: true,
        element: <EmployeeOnBoard />,
      },
      {
        path: 'set-password',
        element: <Login />,
      },
    ],
  },
  {
    path: 'generate-pass',
    element: <GeneratePass />,
  },
  {
    path: 'create-password',
    element: <EnterpriseOnboardLayout />,
    children: [
      {
        path: '',
        index: true,
        element: <OnboardEnterprise submit={submitInvitePassword} successState={INVITE_SUCCESS_STATE} />,
      },
    ],
  },
  {
    path: 'demo',
    // element: <Demos />,
  },
  {
    path: 'pass/:passCode',
    element: <Download />,
  },
  {
    path: 'campaign/:campaignId',
    element: <CampaignJoin />,
  },
  {
    path: 'campaign/enrollment/:code',
    element: <CampaignStatus />,
  },
  {
    path: 'marketplace',
    element: <Marketplace />,
  },
  {
    path: 'marketplace/:id',
    element: <BrandDetails />,
  },
  {
    path: 'w/:slug',
    element: <Storefront />,
  },
  {
    path: 'w/:slug/product/:productId',
    element: <Storefront />,
  },
]

export default PublicRoutes
